import React from 'react';
import { Observe } from 'rewire-core';
import { WithStyle } from 'rewire-ui';
import classNames from 'classnames';
import InfoMessagesView from '../schedule/InfoPanelMessagesView';
import { Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { IMessage } from '../DataTypes';
import { withStyles } from '../utility/styles';
import { UTC } from 'rewire-common';

const styles = (theme: Theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    flex: '0 1 auto',
    flexDirection: 'column',
    minHeight: '158px',
  },
  header: {
    flex: 'none',
    margin: '4px 0px 8px 0px',
    color: theme.palette.primary.main,
  },
  messages: {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
  },
});

interface IMessagesProps {
  title: string;
  titleVariant?: any;
  messages: IMessage[];
  viewOnly?: boolean;
  effective?: () => UTC | undefined;
  className?: string;
  onClick?: (message: IMessage) => void;
}

type MessagesProps = WithStyle<ReturnType<typeof styles>, IMessagesProps>;

class MessagesView extends React.PureComponent<MessagesProps> {
  constructor(props: MessagesProps) {
    super(props);
  }

  render() {
    return (
      <Observe
        render={() => {
          const { classes, className, title, titleVariant, messages, viewOnly, onClick, effective } = this.props;

          return (
            <div className={classNames(className, classes.root)}>
              <div className={classes.header}>
                <Typography variant={titleVariant}>{title}</Typography>
                <InfoMessagesView
                  effective={effective}
                  className={classes.messages}
                  messages={messages}
                  viewOnly={viewOnly}
                  onClick={onClick}
                />
              </div>
            </div>
          );
        }}
      />
    );
  }
}

export default withStyles<IMessagesProps>(styles, MessagesView);
